// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"0b93724d","474":"9668e98f","497":"626fc188","685":"1bb82a41","900":"6396f647","993":"e3aa4531"}[chunkId] + ".chunk.js";
};